import { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import UserAvatar from '../../userAvatar';
import ActionButton from '../../actionButton';
import ShareTypeBox from '../../shareTypeBox';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  userAvatar: {
    width: 'calc(100% - 24px)',
  },
  avatarLabel: {
    color: primary.bluish2,
    fontSize: 16,
    lineHeight: '20px',
    marginLeft: 0,
    paddingRight: spacing(1.5),
    width: '100%',
    userSelect: 'none',
  },
  avatarLabelSelected: {
    color: primary.bluish1,
    fontFamily: 'ProximaNova-Bold',
    fontSize: 14,
    lineHeight: '18px',
  },
  box: {
    minWidth: 'fit-content',
  },
  closeIconButton: {
    height: 24,
    width: 24,
  },
  closeIcon: {
    height: 16,
    width: 16,
    '& path': {
      fill: primary.bluish1,
    },
  },
  closeIconDisabled: {
    '& path': {
      fill: primary.bluish5,
    },
  },
}));

const VirtualSelectedUser = ({
  translations,
  user,
  typeLabel = '',
  shouldHandleTypeLabel = false,
  onDeselect,
}) => {
  const classes = useStyles();

  const handleDeselect = useCallback(
    () => onDeselect(user),
    [user, onDeselect]
  );

  return (
    <div className={classes.root}>
      <UserAvatar
        className={classes.userAvatar}
        labelClass={classNames(
          classes.avatarLabel,
          classes.avatarLabelSelected
        )}
        user={user}
        caption
        small
      />
      {shouldHandleTypeLabel && typeLabel && (
        <ShareTypeBox className={classes.box} label={typeLabel} />
      )}
      <ActionButton
        className={classes.closeIconButton}
        iconClass={classNames(classes.closeIcon, {
          [classes.closeIconDisabled]: user.isDisabled,
        })}
        type={ACTION_BUTTON_TYPES.CLOSE}
        disabledTooltipText={translations.disabledUserTooltip}
        isDisabled={user.isDisabled}
        onClickHandler={handleDeselect}
      />
    </div>
  );
};

VirtualSelectedUser.propTypes = {
  translations: PropTypes.object.isRequired,
  typeLabel: PropTypes.string,
  user: PropTypes.object.isRequired,
  shouldHandleTypeLabel: PropTypes.bool,
  onDeselect: PropTypes.func.isRequired,
};

export default memo(VirtualSelectedUser);
